<template>
  <Alert
    v-if="showAlert"
    :message="alertMessage"
    :alertType="alertType"
    :closable="alertClosable"
    :alertIcon="alertIcon"
    @onClose="dismissAlert"
  />
  <div class="main-body">
    <div class="container-fluid" v-if="currentStep === 'notcancelable'">
      <img
        :src="`${useAsset('img/credit-line/sorryno.png')}`"
        class="mx-auto d-block"
        alt="sorry"
      />
      <div id="other-offer-card" class="mt-4 mb-5">
        <p>{{ t("NOTCANCELABLETEXT") }}</p>
      </div>
    </div>
    <div
      class="container-fluid mt-3"
      v-if="currentStep === 'cancelable-confirm'"
    >
      <h3>{{ t("CONFIRMCANCEL") }}</h3>
      <div class="benefits-summary mt-4">
        <h6 class="lose-access">{{ t("LOSEACCESSTO") }}:</h6>
        <div class="d-flex align-items-center mt-4">
          <img
            class="me-3 cancel-icon"
            :src="useAsset('img/credit-line/credit-card/creditCancelCards.png')"
            alt="lose_cards"
          />
          <h6 class="light-text p-0 m-0">
            {{ t("LOSE_CARDS") }}
          </h6>
        </div>
        <div class="d-flex align-items-center mt-4">
          <img
            class="me-3 cancel-icon"
            :src="
              useAsset('img/credit-line/credit-card/creditCancelDiscounts.png')
            "
            alt="lose_discounts"
          />
          <h6 class="light-text p-0 m-0">
            {{ t("LOSE_DISCOUNTS_AND_BENEFITS") }}
          </h6>
        </div>
        <div class="d-flex align-items-center mt-4">
          <img
            class="me-3 cancel-icon"
            :src="
              useAsset(
                'img/credit-line/credit-card/creditCancelWithdrawals.png'
              )
            "
            alt="lose_withdrawals"
          />
          <h6 class="light-text p-0 m-0">
            {{ t("LOSE_WITHDRAWALS") }}
          </h6>
        </div>
        <div class="d-flex align-items-center mt-4">
          <img
            class="me-3 cancel-icon"
            :src="
              useAsset('img/credit-line/credit-card/creditCancelExtraMoney.png')
            "
            alt="lose_extra_money"
          />
          <h6 class="light-text p-0 m-0">
            {{ t("LOSE_EXTRA_MONEY") }}
          </h6>
        </div>
        <div class="d-flex align-items-center mt-3 mb-2">
          <img
            class="me-3 cancel-icon"
            :src="
              useAsset('img/credit-line/credit-card/creditCancelInterest.png')
            "
            alt="lose_0_interests"
          />
          <h6 class="light-text p-0 m-0">
            {{ t("LOSE_0_INTERESTS") }}
          </h6>
        </div>
      </div>
      <div class="mt-4 text-center">
        <h6 class="light-text p-0">
          {{ t("CANCEL_WARNING") }}
        </h6>
      </div>
      <div class="mt-5 text-center">
        <button class="backdown-btn mb-3 button-text" @click="keepCl()">
          {{ t("NOKEEP") }}
        </button>
        <br />
        <a
          href="javascript:;"
          class="confirm-link"
          @click="currentStep = 'cancelable-survey'"
        >
          {{ t("YESCANCEL") }}
        </a>
      </div>
    </div>
    <div class="container-fluid" v-if="currentStep === 'cancelable-survey'">
      <h3>{{ t("SORRYYOURLEAVING") }}</h3>
      <h6 class="mt-3" style="font-weight: normal">{{ t("WHYLEAVING") }}</h6>
      <div id="options-section" class="mt-10 text-center">
        <button
          class="mt-3"
          :class="selectedReason === 1 ? 'active-option' : 'option-btn'"
          @click="setSelectedOption(1)"
        >
          {{ t("CANCELREASONS.FIRST") }}
        </button>
        <button
          class="mt-3"
          :class="selectedReason === 2 ? 'active-option' : 'option-btn'"
          @click="setSelectedOption(2)"
        >
          {{ t("CANCELREASONS.SECOND") }}
        </button>
        <button
          class="mt-3"
          :class="selectedReason === 7 ? 'active-option' : 'option-btn'"
          @click="setSelectedOption(7)"
        >
          {{ t("CANCELREASONS.SEVENTH") }}
        </button>
        <button
          class="mt-3"
          :class="selectedReason === 4 ? 'active-option' : 'option-btn'"
          @click="setSelectedOption(4)"
        >
          {{ t("CANCELREASONS.FOURTH") }}
        </button>
        <button
          class="mt-3"
          :class="selectedReason === 6 ? 'active-option' : 'option-btn'"
          @click="setSelectedOption(6)"
        >
          {{ t("CANCELREASONS.SIXTH") }}
        </button>
        <div class="mt-5 text-center">
          <button class="backdown-btn mb-3 button-text" @click="keepCl()">
            {{ t("NOKEEP") }}
          </button>
          <br />
          <a
            href="javascript:;"
            class="confirm-link"
            @click="sendCancelation()"
          >
            {{ t("YESCANCEL") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.option-btn {
  width: 100%;
  background-color: $pj-color-white;
  border-radius: 5px;
  color: $pj-color-black;
  text-align: left;
  padding-left: 2.5%;
  border-color: $pj-color-light-gray;
  border-width: thin;
  min-height: 50px;
}

.active-option {
  width: 100%;
  border: none;
  background-color: $pj-color-yellow-green;
  border-radius: 5px;
  color: $pj-color-white;
  text-align: left;
  padding-left: 2.5%;
  min-height: 50px;
}

.cancel-confirm-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  height: 50px;
  border: none;
  bottom: 35px;
  left: 18px;
  width: 100%;
}

.benefits-summary {
  display: flex;
  flex-direction: column;
  background: $pj-color-lighter-gray;
  padding: 10px;
  border-radius: 16px;
}

.backdown-btn {
  background: $pj-color-green;
  border-radius: 5px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 85%;
  height: 40px;
  border: none;
}

.confirm-link {
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-red !important;
  text-decoration: none;
  font-weight: bold;
}

.lose-access {
  color: $pj-color-red;
  text-align: left;
  justify-content: center;
  font-weight: bold;
}

.light-text {
  font-weight: normal;
}

.cancel-icon {
  width: 34px;
  height: 33px;
}

.button-text {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
}
</style>

<script lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { defineComponent, ref } from "vue";
import { Service } from "@/apps/credit-line/services/network.service";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import Alert from "@/shared-components/common/Alert.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";

declare const Android: AndroidInterface;

export default defineComponent({
  components: {
    Alert,
  },
  setup() {
    const { t } = useI18n();
    let navbarType = ref("goBack");
    let screenTitle = ref(t("CANCELCREDITLINE"));
    let CreditLineService = new Service();
    const alertType = "alert-danger";
    let alertMessage = ref(t("CANNOTCANCELERROR"));
    const alertIcon = ref("fa fa-exclamation-triangle");
    let showAlert = ref(false);
    const alertClosable = ref(true);
    let currentStep = ref("cancelable-confirm");
    let selectedReason = ref(0);

    const dismissAlert = () => {
      showAlert.value = false;
    };

    const setSelectedOption = (selected: number) => {
      selectedReason.value = selected;
    };

    const sendCancelation = async () => {
      if (selectedReason.value === 0) {
        alertMessage.value = t("PLEASESELECTCANCELREASON");
        showAlert.value = true;
      } else {
        logAnalyticsEvent(
          AnalyticEvents.CreditLine.CancelCreditLine,
          "Offer",
          "",
          { reason: selectedReason.value }
        );
        try {
          const response = await CreditLineService.closeCreditLine({
            deviceTag: AuthenticationHelper.getDeviceTag(),
            reason: selectedReason.value,
          });
          if (response.status === 200) {
            if (response.data?.status === "closed") {
              if (isAndroid()) {
                Android.creditLineCanceled();
              }
            }
          }
        } catch (err) {
          alertMessage.value = t("CANNOTCANCELERROR");
          showAlert.value = true;
          DatadogLogger.Log(
            "CL Error:" + err.response?.data.message,
            err,
            LogType.ERROR
          );
        }
      }
    };

    const keepCl = () => {
      Android.dismissWebView();
    };

    return {
      t,
      alertMessage,
      alertIcon,
      alertType,
      alertClosable,
      showAlert,
      dismissAlert,
      navbarType,
      currentStep,
      screenTitle,
      selectedReason,
      setSelectedOption,
      sendCancelation,
      useAsset,
      keepCl,
    };
  },
});
</script>
